export default "__VITE_ASSET__6aqvkeXm__"